import styled, { css } from 'styled-components';

import { getFontStyle } from '~components/Text/helper';

export const Menu = styled.a<{ isSelected?: boolean; isNew?: boolean }>`
  height: 100%;
  align-items: center;
  display: flex;
  cursor: pointer;
  flex: 0 0 auto;
  scroll-snap-align: start;
  color: ${({ theme }) => theme.colors.gray800};
  border-bottom: 3px solid ${({ theme }) => theme.colors.white100};

  ${({ isSelected }) =>
    isSelected &&
    css`
      color: #d63461 !important;
      border-bottom: 3px solid;
    `}

  &:focus {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.gray800};
    outline: none;
  }

  span {
    position: relative;

    ${({ isNew }) =>
      isNew &&
      css`
        &::after {
          content: 'new';
          position: absolute;
          top: 1px;
          right: -22px;
          color: ${({ theme }) => theme.colors.magenta500};
          ${getFontStyle('midium120_C2')}
        }
      `}
  }
`;
